import log from 'loglevel';
import { DocEvent, DoodleEvent } from '../view/EventEnum';
import DocModuler from './../DocModuler';
import { ContainerType } from '../common/Constant';

const objMap = {
  1: 'path',
  2: 'path',
  3: 'rect',
  4: 'ellipse',
  5: '',
  6: 'textbox',
  7: 'picture',
  8: 'isotriangle',
  9: 'righttriangle',
  10: 'line',
  11: 'singlearrow',
  12: 'doublearrow'
};
/**
 * 消息解析器
 *
 * @export
 * @class MsgParser
 * @author zhenliang.sun
 */
export default class MsgParser {
  constructor(store = null) {
    this.store = store;
  }

  /**
   * 接收到消息过后，进行统一的第一步消息解析
   *
   * @param {*} msg
   * @returns 返回解析后的消息
   * @memberof MsgParser
   */
  analyze(msg) {
    log.info(`analyze message ${msg}`);
    return msg;
  }

  /**
   * 发送消息的之前， 统一添加一些标识信息 到消息体内
   *
   * @param {*} msg
   * @returns 返回加工过的消息结构体
   * @memberof MsgParser
   */
  parse(msg) {
    const s = this.store;
    const info = s.getKV('info');
    // log.info(`parse message ${JSON.stringify(msg)}`);
    let wrapper = {};
    wrapper.hash = info['hash'] || '';
    wrapper.uniqueID = Date.now();
    wrapper.currentPage = info['slideIndex'] || 0;
    wrapper.page = info['slidesTotal'] || 0;
    wrapper.currentStep = info['stepIndex'] || 0;
    wrapper.step = info['stepsTotal'] || 0;
    wrapper.cw = s.getKV('originW') || this._getWrapperSize().width;
    wrapper.ch = s.getKV('originH') || this._getWrapperSize().height;
    // 如果取不到图片的宽高，就把舞台的宽高设置上去
    wrapper.width = info['originWidth'] !== 1 ? info['originWidth'] : wrapper.cw;
    wrapper.height = info['originHeight'] !== 1 ? info['originHeight'] : wrapper.ch;
    wrapper.cid = s.getKV('cid');
    wrapper.ext = s.getKV('ext'); // 扩展名
    wrapper.coreVersion = DocModuler.version;
    wrapper.doc_type = s.getKV('docType') || 1;
    wrapper.command = msg;

    if (msg.length === 0) {
      wrapper.flipOver = 0;
    } else {
      if (!msg[0].hasOwnProperty('event')) {
        wrapper.flipOver = 0;
      } else {
        if (msg[0]['event'] === DocEvent.PAGE_CHANGE) {
          wrapper.flipOver = 1;
        } else {
          wrapper.flipOver = 0;
        }
      }
    }

    var op = 'special';
    // 翻页、步数更新、创建容器、销毁容器
    if (msg[0].hasOwnProperty('event')) {
      switch (msg[0]['event']) {
        case 'container':
          op = msg[0]['type'];
          break;
        case DocEvent.PAGE_CHANGE:
          op = 'filpover';
          break;
        case DocEvent.STEP_CHANGE:
          op = 'stepupdate';
          break;
        case 'doodle':
          // 画笔、涂鸦相关
          // op = msg[0].data['type'] || ''
          op = this._getDoodleOp(msg[0]);
          break;
      }
    }

    msg[0].op = op;
    msg[0].is_board = s.getKV('type') === ContainerType.DOCUMENT ? 1 : 2;
    return wrapper;
  }

  /**
   * 获取包装器尺寸，目的为防止获取 originW和 originH为0的问题
   *
   * @returns
   * @memberof MsgParser
   */
  _getWrapperSize() {
    const elId = this.store.getKV('rootId');
    if (elId === '' || elId === undefined) {
      return {
        width: 300,
        height: 150
      };
    }

    let el = document.getElementById(elId);

    let result = {
      width: el.clientWidth,
      height: el.clientHeight
    };
    return result;
  }

  _getDoodleOp(evtObj) {
    let str = '';
    switch (evtObj.type) {
      case DoodleEvent.ADD:
        str = objMap[evtObj.data.gtype];
        break;
      case DoodleEvent.MODIFY:
        str = 'modify';
        break;
      case DoodleEvent.REMOVE:
        str = 'eraser';
        break;
      case DoodleEvent.REMOVE_ALL:
        str = 'clear';
        break;
      case DoodleEvent.SELECTED:
        str = 'select';
        break;
      case DoodleEvent.DESELECTED:
        str = 'deselect';
        break;
      case DoodleEvent.SELECT_CHANGED:
        str = 'selectchange';
        break;
      case DoodleEvent.UNDO:
        str = 'undo';
        break;
      case DoodleEvent.REDO:
        str = 'redo';
        break;
      default:
        break;
    }

    return str;
  }
}
